import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

export default function AdminDesk({ course, batch, student }) {
  const [adminDesk, setAdminDesk] = useState(false);
  const [level, setLevel] = useState("");
  const [examCount, setExamCount] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");

  useEffect(() => {
    setPaymentStatus(student[`${course}${level}payment`]);
  }, [level]);

  const upgradeLevel = (level, paymentStatus, totalExams = 3) => {
    totalExams = Number(totalExams) || 3;
    const levelKey = `${course}${level}`;

    const exams = Array.from({ length: totalExams }, (_, i) => ({
      name: `Exm ${i + 1}`,
      Score: 0,
    }));

    const data = {
      [`${levelKey}payment`]: paymentStatus,
      [`${levelKey}Total`]: student[`${levelKey}Total`] || 0,
      [`${levelKey}data`]: student[`${levelKey}data`] || exams,
    };

    axios
      .put(
        `${process.env.REACT_APP_BACKEND_API}/${course}/accessLevelTwo/${batch}/${student.sn}`,
        data,
      )
      .then(() => toast.success("Level upgraded successfully!"))
      .catch(() => toast.error("Update failed"));
  };

  return (
    <div>
      <div className="text-center mt-40">
        <div className="my-5  mx-auto">
          <div className="p-10 bg-slate-200 rounded-sm">
            <div className="flex items-center justify-center">
              <p className="text-xl font-medium text-purple-600 mr-10">
                Admin Support
              </p>
              <input
                type="checkbox"
                className="toggle toggle-primary"
                onChange={(e) => setAdminDesk(e.target.checked)}
              />
            </div>

            {adminDesk && (
              <div className="my-10">
                {/* Upgrade Level */}
                <div className="flex flex-col items-center">
                  <div className="join">
                    <div>
                      <div>
                        <input
                          className="input join-item"
                          placeholder="Level"
                          value={level}
                          onChange={(e) => setLevel(e.target.value)}
                        />
                      </div>
                    </div>
                    <div>
                      <input
                        className="input join-item"
                        placeholder="Payment Status"
                        value={paymentStatus}
                        onChange={(e) => setPaymentStatus(e.target.value)}
                      />
                    </div>
                    <div>
                      <input
                        className="input join-item"
                        placeholder="Exm"
                        value={examCount}
                        onChange={(e) => setExamCount(e.target.value)}
                      />
                    </div>
                    <div className="">
                      <button
                        className="btn join-item"
                        onClick={() =>
                          upgradeLevel(level, paymentStatus, Number(examCount))
                        }
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
                <br />

                {/* Update payment */}
                {/* <div className="flex flex-col items-center">
                  <div className="join">
                    <div>
                      <div>
                        <input
                          className="input join-item"
                          placeholder="Level"
                          value={level}
                          onChange={(e) => setLevel(e.target.value)}
                        />
                      </div>
                    </div>
                    <div>
                      <input
                        className="input join-item"
                        placeholder="Status"
                        value={paymentStatus}
                        onChange={(e) => setPaymentStatus(e.target.value)}
                      />
                    </div>
                    <div className="">
                      <button
                        className="btn join-item"
                        onClick={() => paymentUpdate(level, paymentStatus)}
                      >
                        Update Payment
                      </button>
                    </div>
                  </div>
                </div> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
